/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadPccPatientDetailsRequest
 */
export interface UploadPccPatientDetailsRequest {
    /**
     * 
     */
    push_summary_report: boolean;
    /**
     * 
     */
    push_screener_results: boolean;
    /**
     * 
     */
    push_clinic_package: boolean;
}

/**
 * Check if a given object implements the UploadPccPatientDetailsRequest interface.
 */
export function instanceOfUploadPccPatientDetailsRequest(value: object): value is UploadPccPatientDetailsRequest {
    if (!('push_summary_report' in value) || value['push_summary_report'] === undefined) return false;
    if (!('push_screener_results' in value) || value['push_screener_results'] === undefined) return false;
    if (!('push_clinic_package' in value) || value['push_clinic_package'] === undefined) return false;
    return true;
}

export function UploadPccPatientDetailsRequestFromJSON(json: any): UploadPccPatientDetailsRequest {
    return UploadPccPatientDetailsRequestFromJSONTyped(json, false);
}

export function UploadPccPatientDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadPccPatientDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'push_summary_report': json['push_summary_report'],
        'push_screener_results': json['push_screener_results'],
        'push_clinic_package': json['push_clinic_package'],
    };
}

export function UploadPccPatientDetailsRequestToJSON(json: any): UploadPccPatientDetailsRequest {
    return UploadPccPatientDetailsRequestToJSONTyped(json, false);
}

export function UploadPccPatientDetailsRequestToJSONTyped(value?: UploadPccPatientDetailsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'push_summary_report': value['push_summary_report'],
        'push_screener_results': value['push_screener_results'],
        'push_clinic_package': value['push_clinic_package'],
    };
}

